export default "__VITE_ASSET__DTNUTI$R__"